import React, { ReactNode } from "react";
import "../breadcrumbs/styles.css";

// interface BreadcrumbsItems {
//   label: string;
//   path?: string;
//   icon?: ReactNode;
// }

// interface BreadcrumbsProps {
//   items: BreadcrumbsItems[];
//   className?: string;
// }

const Breadcrumbs = ({ items, className }) => {
  return (
    <ul className="breadcrumb-list">
      {items.map((item, index) => {
        const isActive = index === items.length - 1;
        return (
          <li
            key={item.path}
            className={`breadcrumb-item`}
          >
            {!isActive ? (
              <a href={item.path} className="breadcrumb-link">
                {item.label}
              </a>
            ) : (
              <span className="breadcrumb-label">{item.label}</span>
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default Breadcrumbs;
